export default "__VITE_ASSET__BpYsO4HJ__"